<template lang="pug">
v-card.mb-3
  v-card-text.pt-1
    v-tabs(v-model="kategorie")
      v-tab(v-for="kategorie in kategorien" :key="kategorie.id") {{kategorie.name}}
      v-tab-item(v-for="kategorie in kategorien" :key="kategorie.id")
        v-layout.mt-3(row wrap)
          v-flex(xs12 md6 lg4 xl3 v-for="artikel in kategorie.artikel" :key="artikel.id"): v-card(height="100%")
            v-img(@click="artikel.beschreibung ? artikel.showDetails = true : ''" :src="artikel.produktbild || ''"  :aspect-ratio="4/3")
            v-card-title.pb-0 {{artikel.name}}
            v-card-text
              div.mb-2(v-html="artikel.einleitung")
              v-layout
                v-spacer
                v-btn(v-if="artikel.link" :href="artikel.link" target="_blank" small)
                  v-icon(left) language
                  | Web
                v-dialog(v-model="artikel.showDetails" v-if="artikel.beschreibung || artikel.art !== 'artikel'" lazy max-width="900")
                  v-btn(slot="activator" small)
                    v-icon(left) description
                    | Details
                  v-card(v-if="artikel.showDetails")
                    v-card-title
                      div.pr-3(v-if="artikel.produktbild"): v-img(:src="artikel.produktbild" :aspect-ratio="4/3" width="50")
                      div {{artikel.name}}
                      v-spacer
                      div: v-btn(@click="artikel.showDetails = false" icon): v-icon close
                    v-card-text
                      template(v-if="artikel.art === 'visitenkarte'")
                        v-layout(:wrap="$vuetify.breakpoint.smAndDown")
                          v-flex: div(v-html="artikel.beschreibung")
                          v-flex: meine-visitenkarte
                      template(v-else)
                        div(v-html="artikel.beschreibung")
              v-divider.my-3
              v-layout
                v-flex
                  template(v-if="artikel.anzahlen")
                    v-select(label="Anzahl" v-model="artikel.anzahl" :items="artikel.anzahlen.map(([anz,pr]) => anz)" :hint="formatEur(preisForArtikelanzahl(artikel), true)" persistent-hint style="max-width: 6em")
                  template(v-else-if="artikel.art != 'freitext'")
                    v-text-field(label="Anzahl" v-model.number="artikel.anzahl" :hint="formatEur(artikel.preis, true)" persistent-hint style="max-width: 6em")
                v-flex: v-btn(@click="bestellen(artikel)" :color="artikel.bestellt ? 'success' : ''" :disabled="!(isFinite(artikel.anzahl) && artikel.anzahl > 0 && Math.round(artikel.anzahl) === artikel.anzahl)")
                  v-icon add_shopping_cart
                  span.ml-2 {{formatEur(preisForArtikelanzahl(artikel, true), true)}}

    v-data-table.mt-5(v-if="bestellt.length > 0" :items="bestellt" item-key="uid" :headers="headers" :rows-per-page-items="[-1]" hide-actions no-data-text="Warenkorb ist leer")
      template(slot="items" slot-scope="{ item }")
        td {{ item.name }}
        td
          template(v-if="item.anzahlen")
            v-select(single v-model="item.anzahl" :items="item.anzahlen.map(([anz,pr]) => anz)" @input="updateGesamtpreis(item)" style="max-width: 6em")
          template(v-else-if="item.art != 'freitext'")
            v-text-field(single v-model.number="item.anzahl" @input="updateGesamtpreis(item)" style="max-width: 6em")
        td
          template(v-if="item.anzahlen") —
          template(v-else-if="item.art != 'freitext'") {{ formatEur(preisForArtikelanzahl(item)) }}
        td: template(v-if="item.art != 'freitext'") {{ formatEur(item.gesamtpreis) }}
        td
          template(v-if="item.optionen" v-for="option in item.optionen")
            template(v-if="option.type === 'projekt'")
              | {{option.name}}: {{projektName(option.idvalue)}}
            template(v-else-if="option.type === 'checkbox'")
              | {{option.name}}: {{option.boolean ? 'Ja' : 'Nein'}}
            template(v-else)
              | {{option.name}}: {{option.string || ''}}
            br
        td
          template(v-if="item.optionen && item.optionen.length")
            v-btn(@click="bestellen(item.artikel, false, item)" icon): v-icon edit
        td: v-btn(@click="stornieren(item)" icon): v-icon remove_shopping_cart

    .pt-3
      template(v-if="bestellt.length > 0")
       v-btn(@click="bestellungAbsenden" :loading="loading > 0" color="primary" :disabled="!user || !user.id || !isFinite(summe) || isNaN(summe)") Kaufen {{formatEur(summe)}}
       template(v-if="!user || !user.id") Sie Müssen Eingeloggt sein um bestellen zu können

    v-dialog(:value="true" v-if="confirmVisitenkarte" @input="cancelEdit()" lazy max-width="600")
      v-card
        v-card-text
          meine-visitenkarte(:projekt-id="editProjektId")
          .pt-3
            | Wenn die Daten nicht stimmen, wende Dich bitte <strong>vor</strong> dem Absenden der Bestellung an die Poststelle (030 61 39 04 10), um Deine Daten in der Telefonliste korrigieren zu lassen.
            br
            br
            | Achtung die Farbe wird im Druck je Abteilung vergeben.
            br
            | (Dies ist nur eine Vorschau. Formatierung kann/wird auf der finalen Version abweichen)
            template(v-for="option in editOptionen")
              template(v-if="option.type === 'checkbox'")
                v-checkbox(:label="option.name" v-model="option.boolean")
              template(v-else-if="option.type === 'projekt'")
                v-select(:label="option.name" v-model="option.idvalue" :items="projekte" item-text="name" item-value="id" v-if="projekte.length > 1")
              template(v-else-if="option.type === 'textarea'")
                v-textarea(:label="option.name" v-model="option.idvalue")

        v-card-actions
          v-btn(@click="bestellen(confirmVisitenkarte, true)" outline color="primary") Die Daten stimmen.
          v-btn(@click="cancelEdit()" outline) Abbrechen

    v-dialog(:value="true" v-if="confirmFreitext" @input="cancelEdit()" lazy max-width="600")
      v-card
        v-card-title
          div.pr-3(v-if="confirmFreitext.produktbild"): v-img(:src="confirmFreitext.produktbild" :aspect-ratio="4/3" width="50")
          div {{confirmFreitext.name}}
        v-card-text
          div(v-html="confirmFreitext.beschreibung")
          template(v-for="option in editOptionen")
            template(v-if="option.type === 'textarea'")
              v-textarea(:label="option.name" v-model="option.string")

        v-card-actions
          v-btn(@click="bestellen(confirmFreitext, true)" :disabled="!editOptionen[0] || !editOptionen[0].string" outline color="primary") Ok
          v-btn(@click="cancelEdit()" outline) Abbrechen

</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import { user } from '../../router'
import uuidv4 from 'uuid/v4'
import { sortBy } from 'lodash'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  data() {
    return {
      user,
      currentUser: null,
      confirmVisitenkarte: null,
      confirmFreitext: null,
      editOptionen: null,
      editItem: null,
      kategorie: null,
      kategorien: [],
      bestellt: [],
      loading: 0,
      itTicketKategorien: [],
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Anzahl', value: 'anzahl' },
        { text: 'Preis', value: 'preis' },
        { text: 'Gesamtpreis', value: 'gesamtpreis' },
        { text: '', sortable: false },
        { text: '', sortable: false },
        { text: '', sortable: false },
      ]
    }
  },
  apollo: {
    currentUser: {
      query: gql`query ExtraItTicketVorgangAufgebenVueCurrentUser {
        currentUser {
          id
          person {
            id
            projekte {
              id
              name
            }
          }
        }
      }`
    },
    itTicketKategorien: {
      query: gql`query ExtraItTicketVorgangAufgebenVueItTicketKategorien($ancestry: [String!]) {
        itTicketKategorien(where: { ancestryIn: $ancestry }) {
          id
          name
          beschreibung
          artikel {
            id
            name
            einleitung
            beschreibung
            link
            preis
            art
            anzahlen
            produktbild(size: "320x")
          }
        }
      }`,
      variables() {
        return {
          ancestry: this.itTicketKategorie ? [this.itTicketKategorie] : []
        }
      }
    }
  },
  watch: {
    itTicketKategorien(itTicketKategorien) {
      const kategorien = []
      itTicketKategorien.forEach(kategorie => {
        const artikel = []
        kategorie.artikel.map(artik => {
          const anzahl = artik.anzahlen ? artik.anzahlen[0][0] : 1
          artikel.push({ ...artik, bestellt: false, anzahl, showDetails: false })
        })
        kategorien.push({ ...kategorie, artikel })
      })
      this.kategorien = kategorien
    }
  },
  computed: {
    itTicketKategorie() {
      return this.extra && this.extra.options && this.extra.options.it_ticket_kategorie && `${this.extra.options.it_ticket_kategorie}` || null
    },
    summe() {
      let summe = 0
      this.bestellt.forEach((artikel) => {
        if (typeof artikel.gesamtpreis === 'number') {
          summe += artikel.gesamtpreis
        } else {
          summe = NaN
        }
      })
      return summe
    },
    projekte() {
      return sortBy(this.currentUser && this.currentUser.person && this.currentUser.person.projekte || [], 'id')
    },
    editProjektId() {
      const option = this.editOptionen && this.editOptionen.find(o => o.type === 'projekt')
      return option && option.idvalue
    }
  },
  methods: {
    projektName(id) {
      const projekt = this.projekte.find(p => p.id == id)
      return projekt && projekt.name || ''
    },
    formatEur(value, hide0) {
      if (hide0 && value <= 0) {
        return ''
      } else if (isFinite(value) && !isNaN(value)) {
        return `${(Math.round(value*100)/100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} €`
      } else {
        return '—'
      }
    },
    preisForArtikelanzahl(artikel, total) {
      const anzahl = artikel.anzahlen && artikel.anzahlen.find(([anz, preis]) => artikel.anzahl === anz)
      if (anzahl) {
        const preis = anzahl[1]
        return preis === 0 ? preis : preis || artikel.preis
      } else if (total) {
        return artikel.preis * artikel.anzahl
      } else {
        return artikel.preis
      }
    },
    bestellen(artikel, force, editItem) {
      let editOptionen
      if (editItem) {
        this.editItem = editItem
        editOptionen = editItem.optionen.map(opt => ({ ...opt }))
      }
      if (!force && artikel.art === 'visitenkarte') {
        this.confirmVisitenkarte = artikel
        this.editOptionen = editOptionen || [{ type: 'checkbox', name: 'Mehrsprachig', boolean: false }, { type: 'projekt', name: 'Projekt', idvalue: (this.projekte && this.projekte[0] && this.projekte[0].id || null) }]
        return
      }
      if (!force && artikel.art === 'freitext') {
        this.confirmFreitext = artikel
        this.editOptionen = editOptionen || [{ type: 'textarea', name: 'Freitext', string: "" }]
        return
      }
      this.confirmFreitext = null
      this.confirmVisitenkarte = null
      let bestellterArtikel = this.bestellt.find(a => a.id === artikel.id)
      if (bestellterArtikel && !bestellterArtikel.anzahlen && (!this.editOptionen || this.editOptionen.length === 0)) {
        bestellterArtikel.anzahl = +bestellterArtikel.anzahl + artikel.anzahl
        this.updateGesamtpreis(bestellterArtikel)
      } else {
        if (this.editItem) {
          this.editItem.optionen = this.editOptionen
          this.updateGesamtpreis(this.editItem)
        } else {
          const artikelNeu = {...artikel, artikel: artikel, uid: uuidv4(), optionen: this.editOptionen }
          this.updateGesamtpreis(artikelNeu)
          this.bestellt.push(artikelNeu)
        }
      }
      this.editItem = null
      this.editOptionen = null
    },
    cancelEdit() {
      this.editOptionen = null
      this.editItem = null
      this.confirmVisitenkarte = null
      this.confirmFreitext = null
    },
    stornieren(bestellterArtikel) {
      const i = this.bestellt.indexOf(bestellterArtikel)
      if (i >= 0) {
        this.bestellt.splice(i, 1)
      }
      if (this.bestellt.findIndex(artikel => artikel.id === bestellterArtikel.id) < 0) {
        bestellterArtikel.artikel.bestellt = false
      }
    },
    updateGesamtpreis(artikel) {
      if (artikel.anzahlen) {
        const preis = this.preisForArtikelanzahl(artikel)
        artikel.gesamtpreis = typeof artikel.anzahl === 'number' ? preis : NaN
        artikel.artikel.bestellt = artikel.gesamtpreis >= 0 && isFinite(artikel.gesamtpreis)
      } else {
        artikel.gesamtpreis = typeof artikel.anzahl === 'number' ? artikel.preis * artikel.anzahl : NaN
        artikel.artikel.bestellt = artikel.gesamtpreis >= 0 && isFinite(artikel.gesamtpreis)
      }
    },
    bestellungAbsenden() {
      this.loading++
      this.gqlClearAllErrors()
      this.$apollo.mutate({
        mutation: gql`mutation (
            $artikel: [ItAuftraegeInput],
            $itTicketKategorie: ID
        ) {
          itTicketVorgangCreate(
            artikel: $artikel,
            itTicketKategorieId: $itTicketKategorie
          ) { id }
        }`,
        variables: {
          artikel: this.bestellt.map(artikel => ({ id: artikel.id, anzahl: `${artikel.anzahl}`, optionen: artikel.optionen || [] })),
          itTicketKategorie: this.itTicketKategorie,
        },
      }).then((data) => {
        this.loading--
        this.bestellt.forEach(artikel => artikel.artikel.bestellt = false)
        this.bestellt = []
        this.$nextTick(() =>
          alert('Bestellung abgeschickt.')
        )
      }).catch((error) => {
        this.gqlAddErrors(error)
        alert('Ein Fehler is aufgetreten.')
        this.loading--
      })
    }
  }
}
</script>
